// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V6 → V7
 *
 * Upgrade:
 * - 70_Halbtiefbohrung_mit_Protokoll → 9991_Halbtiefbohrung_mit_Protokoll
 * - 9990_Abgrenzbohrung → 9990_Infopunkt
 *
 * Downgrade:
 * - 9991_Halbtiefbohrung_mit_Protokoll → 70_Halbtiefbohrung_mit_Protokoll
 * - 9990_Infopunkt → 9990_Abgrenzbohrung
 */
export const migrationV6ToV7: MigrationDefinition = {
  fromVersion: 6,
  toVersion: 7,

  upgrade(doc: any): any {
    if (doc.type === '70_Halbtiefbohrung_mit_Protokoll') {
      doc.type = '9991_Halbtiefbohrung_mit_Protokoll';
    }
    if (doc.type === '9990_Abgrenzbohrung') {
      doc.type = '9990_Infopunkt';
    }

    doc.version = 7;
    return doc;
  },

  downgrade(doc: any): any {
    if (doc.type === '9991_Halbtiefbohrung_mit_Protokoll') {
      doc.type = '70_Halbtiefbohrung_mit_Protokoll';
    }
    if (doc.type === '9990_Infopunkt') {
      doc.type = '9990_Abgrenzbohrung';
    }

    doc.version = 6;
    return doc;
  },

  dataLossWarnings: []
};
